import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';

import { NotificationBarComponent } from '../components/notification-bar/notification-bar.component';

interface NotificationBarInterface {
  show?: boolean;
  type?: string;
  content?: string;
  timeout?: number;
  onTopOfAll?: boolean;
  showCloseButton?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationBarService {

  private sub = new BehaviorSubject<NotificationBarInterface>({});

  constructor() { }

  public getSub() {
    return this.sub.asObservable();
  }

  public showNotification(type: 'update' | 'success' | 'warning' | 'alert', content: string, timeout?: number, onTopOfAll?: boolean, showCloseButton?: boolean) {
    this.sub.next({show: true, type, content, timeout, onTopOfAll, showCloseButton });
  }

  public hideNotification() {
    this.sub.next({show: false});
  }
}
